import Vue from 'vue';
import helpers from "./mixins/helpers";
if(document.getElementById('task-page')) {
    let test = new Vue({
        mixins: [helpers],
        el: "#task-page",
        data: {
            task: null,
            complete:false,
            steps: 0,
            currentStep: 1,
            netMessage: false,
            startTime: Date.now(),
            endTime: null,
            showBanner: true,

            countdown: {
                enable: false,
                message: null,
                seconds: 0
            },
            load: false
        },
        methods: {
            fetchData() {
                let self = this;
                try {

                    $.ajax({
                        url: '/api/v1/task/view',
                        dataType: "json",
                        data: {id: task_id},
                        success: function (data) {
                            self.task = data;
                            self.steps = data.questions.length;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {
                    console.error(e);

                }
            },
            nextStep(step) {
                let self = this;

                if (!step) {

                   if(self.task.questions[self.currentStep -1  ].answer != undefined && self.task.questions[self.currentStep -1  ].answer.length >= 2){

                       self.currentStep++;

                   }

                } else {

                    self.currentStep = step;

                }

            },
            getResult() {

                if(this.task.questions[this.currentStep -1  ].answer != undefined && this.task.questions[this.currentStep -1  ].answer.length >= 2 && this.load === false){
                    this.load = true;
                    if (this.netMessage === false) {
                        var self = this;
                        this.endTime = Date.now();

                        $.ajax({
                            url: '/api/v1/task/send',
                            dataType: "json",
                            contentType: "application/json",
                            method: 'POST',
                            data: JSON.stringify(self.task.questions),
                            success: function (data) {
                                if(data.status === true){
                                    self.complete = true;
                                    self.load = false;
                                }
                            },
                            fail: function (data) {

                                throw new Error('Ошибка получении данных');

                            }
                        });

                    }

                }



            },
            countDown: function () {
                let self = this;
                if (this.countdown.seconds === 0 && this.countdown.enable === true) {

                    this.countdown.enable = false;
                    this.getResult();

                } else if (this.countdown.seconds > 0) {

                    var message = '';

                    var time = new Date(this.countdown.seconds * 1000);

                    if (time.getUTCHours() > 0) {

                        let hourse = time.getUTCHours();
                        message += hourse + ' ' + self.decOfNum(hourse, ['час', 'часа', 'часов']) + ' ';

                    }

                    if (time.getMinutes() > 0) {

                        let minute = time.getMinutes();
                        message += minute + ' ' + self.decOfNum(minute, ['минута', 'минуты', 'минут']) + ' ';

                    }

                    let seconds = time.getSeconds();

                    message += seconds + ' ' + self.decOfNum(seconds, ['секунда', 'секунды', 'секунд']);

                    this.countdown.seconds--;

                    this.countdown.message = message;

                }

            },
            returnFocus() {
                $('.next-btn').focus();
            }
        },
        mounted() {
            this.fetchData();
        }
    });
    Offline.on('confirmed-up',function () {

        test.netMessage = false;
    });
    Offline.on('confirmed-down',function () {

        test.netMessage = true;

    });
}
